import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

import { envName } from "../config/config";

export function initSentry() {
  const rateLimiter = new SlidingWindowRateLimiter({
    maxRequestsPerWindow: 3,
    windowDurationMs: 10_000,
  });

  try {
    Sentry.init({
      dsn: "https://273c38a86e9eaec1b5b4f1edb66dfb44@o4508094333190144.ingest.de.sentry.io/4508094336008272",
      environment: envName,
      beforeSend: (event) => {
        if (!rateLimiter.trackRequest()) {
          console.error("[Sentry] Error rate limited", event);
          return null;
        }

        return event;
      },
      integrations: [
        Sentry.reactRouterV7BrowserTracingIntegration({
          useEffect: useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
    });
  } catch (error) {
    console.error("Failed to init Sentry", error);
  }
}

class SlidingWindowRateLimiter {
  private requestTimestamps: number[] = [];

  constructor(
    private config: { maxRequestsPerWindow: number; windowDurationMs: number },
  ) {}

  trackRequest(): boolean {
    // eslint-disable-next-line no-restricted-syntax -- internal rate limiting, not a server timestamp
    const currentTime = Date.now();

    // Remove timestamps that are outside of the sliding window
    while (
      this.requestTimestamps.length > 0 &&
      this.requestTimestamps[0] <= currentTime - this.config.windowDurationMs
    ) {
      this.requestTimestamps.shift();
    }

    if (this.requestTimestamps.length >= this.config.maxRequestsPerWindow) {
      return false; // Rate limit exceeded
    }

    // Log the timestamp of the current request
    // eslint-disable-next-line no-restricted-syntax -- internal rate limiting, not a server timestamp
    this.requestTimestamps.push(Date.now());
    return true; // Request allowed
  }
}
